export default {"src":"/_next/static/media/logoFooter.b0535ac2.svg","height":29,"width":34};